// Help copy for the ledger-based revenue reports (account report, admin
// Revenue page). Profit everywhere means the platform fee we collected less
// a flat estimate of Stripe's cost: 3.25% of the card charge plus 30¢ per
// app order or 10¢ per POS card swipe. Cash taken at the gate carries no fee
// and no Stripe cost, so it earns nothing.

export const HELP = {
  eventPerformance:
    'Each event this period, with what customers paid split by how they ' +
    'paid, and what Pit Pay kept after Stripe.',
  revenueByAccount:
    'Every account with sales this period. Profit is what Pit Pay kept: ' +
    'platform fees less an estimate of Stripe processing.',
  annualSales:
    'Season passes and memberships bought this period, and what Pit Pay ' +
    'kept on each after Stripe.',
  appProfit:
    'Platform fees on app orders, less Stripe: 3.25% of the charge plus ' +
    '30¢ per order.',
  posProfit:
    'Platform fees on POS card sales, less Stripe: 3.25% of the charge ' +
    'plus 10¢ per swipe. Cash sales carry no fee, so they add nothing.',
  passProfit:
    'Platform fee on the pass, less Stripe: 3.25% of the charge plus 30¢ ' +
    'per order (shared when several passes are bought together).',
};
